import { render } from "./SetupWizard.vue?vue&type=template&id=2488aba6&scoped=true"
import script from "./SetupWizard.vue?vue&type=script&lang=js"
export * from "./SetupWizard.vue?vue&type=script&lang=js"

import "./SetupWizard.vue?vue&type=style&index=0&id=2488aba6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2488aba6"]])

export default __exports__